export default "__VITE_ASSET__03FTZIK5__"